<template>
  <div
    class="border-gray flex flex-col items-start rounded-lg border bg-white p-4 shadow-md"
  >
    <p class="text-sm text-neutral-subtlest">Last 90 Days</p>
    <div class="flex w-full items-center justify-between">
      <p class="text-xl font-semibold text-dark-gray">
        {{ positivePercentage }}% Reliability Score
      </p>

      <Popper
        placement="top"
        :hover="true"
        trigger="hover"
        :arrow="true"
        offset-distance="6"
      >
        <img
          class=""
          style="top: 0.2rem"
          src="@/assets/info-icon-blue.svg"
          alt="Info icon"
        />
        <template #content>
          <p
            class="icon-tooltip rounded-md bg-dark-gray px-2 py-1 text-center text-xs text-light-gray"
          >
            {{ infoIconText }}
          </p>
        </template>
      </Popper>
    </div>

    <div class="my-2 flex w-full gap-2">
      <span
        class="block h-6 rounded-md bg-green-600 shadow-md"
        :style="`width: ${positivePercentage}%;`"
      ></span>
      <span
        class="block h-6 rounded-md bg-red-600 shadow-md"
        :style="`width: ${negativePercentage}%;`"
      ></span>
    </div>

    <p class="text-neutral-subtlest">Pickup detected by an insured truck</p>

    <div class="flex gap-2">
      <div class="flex items-center gap-1">
        <span class="block h-3 w-3 rounded-full bg-green-600"></span>
        <p class="text-sm text-neutral-subtlest">{{ positivePercentage }}%</p>
      </div>

      <div class="flex items-center gap-1">
        <span class="block h-3 w-3 rounded-full bg-red-600"></span>
        <p class="text-sm text-neutral-subtlest">{{ negativePercentage }}%</p>
      </div>
    </div>
  </div>
</template>

<script>
import Popper from 'vue3-popper';

export default {
  name: 'Reliability Score Card',
  components: {
    Popper,
  },
  props: {
    score: Number,
  },
  data() {
    return {
      infoIconText: 'Reliability Score popover text',
    };
  },
  computed: {
    positivePercentage: function () {
      return this.$props.score;
    },
    negativePercentage: function () {
      return 100 - this.$props.score;
    },
  },
};
</script>
